import { DatePipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { Tc } from '../../../../core/_infrastructure/types/common';
import { TratamientoDesinfeccionService } from '../tratamientodesinfeccion.service';
import { TTratamientoCamViewModel } from '../tratamientodesinfeccion.types';

@Component({
    selector: 'app-tratamientodesinfeccion-edit',
    templateUrl: './tratamientodesinfeccion-edit.component.html',
})
export class TratamientoDesinfeccionEditComponent extends ComponentBase implements OnChanges, OnInit {
    @Input() tratamientoDesinfeccion: TTratamientoCamViewModel;
    @Input() formGroup: FormGroup;
    @Input() campanias: Tc[];

    isCollapsedCabecera = false;

    editMode = false;

    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        public datepipe: DatePipe,
        protected tratamientoDesinfeccionService: TratamientoDesinfeccionService,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit() {
        this.updateForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.tratamientoDesinfeccion?.currentValue) {
            this.tratamientoDesinfeccion = { ...changes.tratamientoDesinfeccion?.currentValue };
            this.updateForm();
        }
    }

    private updateForm(): void {
        this.formGroup.setValue({
            Id: this.tratamientoDesinfeccion?.Id || null, //not visible but required
            IdCampania: this.tratamientoDesinfeccion?.IdCampania || null,
            FechaCreacion: this.datepipe.transform(this.tratamientoDesinfeccion?.FechaCreacion, 'dd/MM/yyyy') || null,
            FechaBaja: this.datepipe.transform(this.tratamientoDesinfeccion?.FechaBaja, 'dd/MM/yyyy') || null,
            Activo: this.tratamientoDesinfeccion?.Activo || false,
            Tratamiento: this.tratamientoDesinfeccion?.Tratamiento || '',
            ProductoQuimico: this.tratamientoDesinfeccion?.ProductoQuimico || '',
            Concentracion: this.tratamientoDesinfeccion?.Concentracion || '',
            Duracion: this.tratamientoDesinfeccion?.Duracion || '',
            Temperatura: this.tratamientoDesinfeccion?.Temperatura || '',
            Fecha: this.datepipe.transform(this.tratamientoDesinfeccion?.Fecha, 'dd/MM/yyyy') || null,
            InformacionAdicional: this.tratamientoDesinfeccion?.InformacionAdicional || '',
        });

        this.form = this.formGroup;
    }

    /** Pondra en el HTML el titulo de si es Crear o Editar*/

    get title(): string {
        return this.tratamientoDesinfeccion ? 'Editar' : 'Nuevo';
    }
}
